import React from "react";
import * as RENDERERS from "b2b/renderers/ciselnik";

const DOPLNKOVA_SLUZBA = require("b2b-devel/admin/doplnkovasluzba.json");

// eslint-disable-next-line no-unused-vars
const renderCiselnik = (component, val) => {
  const Render = RENDERERS[component];

  return (
    <>
      {Render ? (
        <tr>
          <td>{component}</td>
          <td>
            <Render val={val} />
          </td>
          <td>
            <Render val={val} showPlaceholder />
          </td>
          <td>{JSON.stringify(val)}</td>
        </tr>
      ) : undefined}
    </>
  );
};

export function Renderers() {
  return (
    <>
      <h2>Renderers - ciselnik</h2>
      <div className="b2b-ComponentsExample-rednerers">
        <table>
          <thead>
            <tr>
              <th>name</th>
              <th>result</th>
              <th>result - showPlaceholder</th>
            </tr>
          </thead>
          <tbody>
            {renderCiselnik("DoplnkovaSluzba", DOPLNKOVA_SLUZBA)}
            {renderCiselnik("DoplnkovaSluzbaFull", DOPLNKOVA_SLUZBA)}
            {renderCiselnik("Uzivatel", { jmeno: "Lumír", prijmeni: "Gago" })}
            {renderCiselnik("Zakaznik", { nazev: "Toto je firma a.s." })}
            {renderCiselnik("Projekt", {
              nazevCs: "Toto je projekt",
              nazevEn: "Toto je projekt EN"
            })}
            {renderCiselnik("Produkt", {
              nazevCs: "Toto je produkt",
              nazevEn: "Toto je produkt EN"
            })}
            {renderCiselnik("Smlouva", {
              cislo: "Toto je cislo",
              popis: "Toto je popis"
            })}
            {renderCiselnik("SmlouvaFull", {
              cislo: "Toto je cislo",
              popis: "Toto je popis"
            })}
            {renderCiselnik("ZadostiStav", {
              stavCs: "POTVRZENÝ",
              stavEn: "POTVRZENÝ EN"
            })}
            {renderCiselnik("ZadostiStavPopis", {
              popisCs: "POTVRZENÝ",
              popisEn: "POTVRZENÝ EN"
            })}
            {renderCiselnik("Zdroj", {
              id: 1,
              nazevCs: "VZO",
              popisCs: "Velký zkušení okruh",
              nazevEn: "LTR",
              popisEn: "Large test ring",
              exkluzivita: true,
              pozadavekSmena: true
            })}
            {renderCiselnik("ZdrojFull", {
              id: 1,
              nazevCs: "VZO",
              popisCs: "Velký zkušení okruh",
              nazevEn: "LTR",
              popisEn: "Large test ring",
              exkluzivita: true,
              pozadavekSmena: true
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

Renderers.propTypes = {};

export default React.memo(Renderers);
